"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconStudentFilled = function IconStudentFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.21 24.69L25.31 32.48C25.2266 32.5433 25.1247 32.5775 25.02 32.5775C24.9153 32.5775 24.8134 32.5433 24.73 32.48L11.79 23.24C11.7157 23.1871 11.6284 23.1555 11.5375 23.1487C11.4465 23.1418 11.3554 23.16 11.2741 23.2012C11.1927 23.2424 11.1242 23.3051 11.0759 23.3824C11.0276 23.4597 11.0013 23.5488 11 23.64V37.5C11 37.6326 11.0527 37.7598 11.1464 37.8536C11.2402 37.9473 11.3674 38 11.5 38H36.5C36.6326 38 36.7598 37.9473 36.8536 37.8536C36.9473 37.7598 37 37.6326 37 37.5V25.09C36.9987 24.9988 36.9724 24.9097 36.9241 24.8324C36.8758 24.7551 36.8073 24.6924 36.7259 24.6512C36.6446 24.61 36.5535 24.5918 36.4625 24.5987C36.3716 24.6055 36.2843 24.6371 36.21 24.69Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43 37.94V16.25C42.9982 16.2186 43.0047 16.1874 43.0187 16.1593C43.0328 16.1313 43.0539 16.1074 43.08 16.09L44.69 14.94C44.7938 14.8859 44.8754 14.7972 44.9205 14.6892C44.9656 14.5813 44.9714 14.4609 44.9369 14.3491C44.9024 14.2372 44.8298 14.1411 44.7317 14.0773C44.6336 14.0135 44.5162 13.9861 44.4 14H5.63C5.52327 13.9992 5.41909 14.0325 5.33268 14.0951C5.24627 14.1578 5.18217 14.2464 5.14977 14.3481C5.11736 14.4498 5.11834 14.5592 5.15257 14.6603C5.1868 14.7614 5.25248 14.8489 5.34 14.91L24.73 28.79C24.8134 28.8532 24.9153 28.8875 25.02 28.8875C25.1247 28.8875 25.2266 28.8532 25.31 28.79L39.68 18.52C39.7097 18.4977 39.745 18.4841 39.782 18.4808C39.819 18.4774 39.8562 18.4845 39.8894 18.5011C39.9227 18.5177 39.9506 18.5432 39.9701 18.5748C39.9897 18.6064 40 18.6428 40 18.68V37.94C40.0103 37.9759 40.0103 38.014 40 38.05L37.18 42.7C37.1626 42.7301 37.1533 42.7643 37.1532 42.7992C37.153 42.834 37.162 42.8683 37.1792 42.8986C37.1964 42.9289 37.2212 42.9542 37.2511 42.972C37.2811 42.9898 37.3152 42.9994 37.35 43H39.88C39.917 42.9991 39.9532 42.9885 39.9848 42.9692C40.0164 42.9499 40.0424 42.9226 40.06 42.89L40.82 41.36C40.8364 41.3262 40.8619 41.2976 40.8938 41.2777C40.9256 41.2577 40.9624 41.2471 41 41.2471C41.0376 41.2471 41.0744 41.2577 41.1062 41.2777C41.1381 41.2976 41.1636 41.3262 41.18 41.36L41.94 42.89C41.9576 42.9226 41.9836 42.9499 42.0152 42.9692C42.0468 42.9885 42.083 42.9991 42.12 43H45.65C45.6848 42.9994 45.7189 42.9898 45.7489 42.972C45.7788 42.9542 45.8036 42.9289 45.8208 42.8986C45.838 42.8683 45.847 42.834 45.8468 42.7992C45.8467 42.7643 45.8374 42.7301 45.82 42.7L43 38.05C42.9897 38.014 42.9897 37.9759 43 37.94Z",
    fill: color
  }));
};

IconStudentFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconStudentFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconStudentFilled;
exports.default = _default;